<dx-popup
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [showTitle]="false"
  [showCloseButton]="false"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.3)"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [deferRendering]="false"
  [wrapperAttr]="{ class: 'gpd-popup' }"
  width="50vw"
  height="auto"
  [maxHeight]="'90vh'"
>
  <div class="gpd-popup-inner new-contact-modal">
    <div class="gpd-popup-header">
      <span class="gpd-popup-title" *ngIf="type === 'person'" i18n="@@addNewPersonCaps">Add Person</span>
      <span class="gpd-popup-title" *ngIf="type === 'company'" i18n="@@addNewCompany">Add Company</span>
      <app-gpd-button type="text" icon="cancel" (onClick)="close()"></app-gpd-button>
    </div>

    <div class="gpd-popup-body new-contact-body">
      <!-- The Role block is projected INSIDE each inline form (ng-content), landing between
           its Contact and Tags sections, instead of being appended after the whole form —
           same visual position/order as the Tags section above it. -->
      <app-contacts-add-person-inline
        *ngIf="type === 'person'"
        (onSubmit)="onContactCreated($event)"
      >
        <dx-validation-group #roleValidationGroup>
          <div class="new-contact-role">
            <label class="new-contact-role__label">
              <span i18n="@@role">Role</span>
              <span class="new-contact-role__required">*</span>
            </label>
            <div class="new-contact-role__divider"></div>
            <gpd-role-select [(value)]="role"></gpd-role-select>
          </div>
        </dx-validation-group>
      </app-contacts-add-person-inline>

      <app-contacts-add-company-inline
        *ngIf="type === 'company'"
        (onSubmit)="onContactCreated($event)"
      >
        <dx-validation-group #roleValidationGroup>
          <div class="new-contact-role">
            <label class="new-contact-role__label">
              <span i18n="@@role">Role</span>
              <span class="new-contact-role__required">*</span>
            </label>
            <div class="new-contact-role__divider"></div>
            <gpd-role-select [(value)]="role"></gpd-role-select>
          </div>
        </dx-validation-group>
      </app-contacts-add-company-inline>
    </div>

    <div class="gpd-popup-footer">
      <div class="gpd-popup-footer-left"></div>
      <div class="gpd-popup-footer-right">
        <app-gpd-button type="secondary" icon="cancel" i18n-text="@@cancel" text="Cancel" (onClick)="close()"></app-gpd-button>
        <app-gpd-button
          type="primary"
          icon="check"
          iconColor="white"
          i18n-text="@@save"
          text="Save"
          (onClick)="save()"
        ></app-gpd-button>
      </div>
    </div>
  </div>
</dx-popup>
